<template>
    <!-- 医美11-12新激励排行榜 -->
    <div class="ranking">

        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <div v-for="(v, k) in jobTabs" :key="k">
                <div v-if="currentJobTab == k + 1">
                    <!-- banner -->
                    <img class="banner" :src="`${v.url}20251226/${v.bannerImg}.png`" alt="banner">
                    <span :class="['rule', ` rule${currentJobTab}`]" @click="toRule"> 活动规则 </span>
                    <!-- 奖品 -->
                    <div class="reward-box">
                        <img v-if="showXiBaoEmpConfigShow" class="poster-img" @click="toPoster" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2026-01-04/posters.png" alt="image">
                        <div class="bear-palm">
                            <img :src="`${v.url}20251226/gift${currentJobTab}.png`" alt="">
                        </div>

                        <div class="arrivedWrapper">
                            <img :src="`https://static.beautyfarm.com.cn/beauty_image/20251226/isReward${dataInfo.isReward}.png`" alt="">
                        </div>
                        <p class="update-time">数据更新时间 {{ dataInfo.updateTime }}</p>
                    </div>

                    <div class="bg-color"></div>
                </div>
            </div>
            <div class="ranking-box">
                <div class="tabs-box">
                    <div class="job-tabs">
                        <div>
                            <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ on: currentJobTab == it.dictValue }" @click="onJobTab(it)">
                                {{ it.dictLabel }}
                            </div>
                        </div>
                        <div class="group-tabs">
                            <div class="group-tab-item" :class="{ on: currentGroupTab == j }" v-for="(j, n) in groupTabs" :key="n" @click="onGroupTab(j)">
                                {{ j }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="myWrapper" v-if="myData">
                        <RankingItem :currentJobTab="currentJobTab" isMe :list="[myData]" :currentGroupTab="currentGroupTab" />
                    </div>
                    <div class="ranking-list-item title">
                        <div class="ranking-num">排名</div>
                        <div class="ranking-name">{{ jobTabs[currentJobTab - 1]?.title1 }}</div>
                        <div class="ranking-order">{{ jobTabs[currentJobTab - 1]?.title2 }}</div>
                        <div class="ranking-bonus">{{ jobTabs[currentJobTab - 1]?.title3 }}</div>
                    </div>
                    <RankingItem :currentJobTab="currentJobTab" :list="list" :currentGroupTab="currentGroupTab" :dataInfo="dataInfo" />
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { debounce } from 'lodash';
    import { ActionSheet, Toast } from 'vant'
    export default {
        name: 'newCustRankList',
        components: {
            RankingItem,
            [ActionSheet.name]: ActionSheet
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [], // 职位分类标签列表
                currentJobTab: '1',
                currentGroupTab: '美田直营', // 当前选中的分组
                loading: false, // 是否正在加载
                currentMoldTab: '', // 当前选中第三层分组
                finished: false, // 是否加载完成
                showXiBaoEmpConfigShow: false,
                list: [], // 排名列表数据
                page: 1, // 当前页码
                error: false, // 是否发生错误
                themeArr: [
                    {
                        "bgColor": "#FFE68F",
                        "url": "https://static.beautyfarm.com.cn/beauty_image/",
                        "bannerImg": "banner1",
                        "title1": "客户经理",
                        "title2": "消费新客人数 ",
                        "title3": "预计奖金"
                    },
                    {
                        "bgColor": "#8B020F",
                        "url": "https://static.beautyfarm.com.cn/beauty_image/",
                        "bannerImg": "banner2",
                        "title1": "客户经理",
                        "title2": "流失激活人数 ",
                        "title3": "预计奖金"
                    },
                    {
                        "bgColor": "#8B020F",
                        "url": "https://static.beautyfarm.com.cn/beauty_image/",
                        "bannerImg": "banner3",
                        "title1": "客户经理",
                        "title2": "销售女性新客 ",
                        "title3": "预计奖金"
                    }
                ],
                dataInfo: {},  //后端整个详情
                myData: {},     //我的个人数据
                groupTabs: ['美田直营', '贝黎诗直营', '贝黎诗加盟']
            }
        },
        async mounted() {
            await this.getjobTabs()
            await this.getDataList()
            await this.showXiBaoEmpConfigGet()
        },
        methods: {
            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {
                if (this.finished) return
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                try {
                    const params = {
                        bu: this.currentGroupTab || '',
                        page: this.page,
                        type: this.currentJobTab,
                        limit: 10
                    }
                    const { code, msg, data } = await request({
                        url: '/nxCustIncentive/getCustIncentivePage',
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    Toast.clear();
                    this.dataInfo = data
                    this.myData = Object.keys(data.empRankingInfo).length === 0 ? null : data.empRankingInfo
                    const list = data && data.rankingList
                    if (this.page == 1) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    // this.$toast(error)
                }

            }, 500),
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                this.currentJobTab = value.dictValue;
                this.currentGroupTab = '美田直营'
                this.page = 1
                this.finished = false
                this.error = false;
                this.getDataList()
            },
            // 切换分组标签
            onGroupTab(v) {
                this.currentGroupTab = v;
                this.finished = false
                this.error = false;
                this.page = 1
                this.getDataList()
            },
            toRule() {
                this.$router.push({ path: '/newCustRankListRules', query: { currentJobTab: this.currentJobTab } })
            },
            toPoster() {
                this.$router.push({ path: '/newCustRankListPoster', query: { currentJobTab: this.currentJobTab, currentGroupTab: this.currentGroupTab } })
            },
            // 获取喜报权限
            showXiBaoEmpConfigGet() {
                request({
                    baseURL: window.SITE_CONFIG['apiURLBase'],
                    url: "/sys/params/code/showXiBaoEmpConfig",
                    method: "get",
                })
                    .then((res) => {
                        let showXiBaoEmpConfig = res.data ? res.data.split(',') : []
                        this.showXiBaoEmpConfigShow = showXiBaoEmpConfig.includes(localStorage.getItem('empNo'))
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 获取职位分类标签
            async getjobTabs() {
                const { data } = await request({
                    url: '/dict/type/dictList',
                    method: 'get',
                    params: { dictType: 'newCust_rankList' }
                })
                // 重组数据，该处理应新建数据进去
                const newArr = data.map((item, index) => {
                    return { ...item, ...this.themeArr[index] }
                })
                this.jobTabs = newArr
            },
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;

        .flex-around {
            display: flex;
            justify-content: space-around;
        }

        .flex-between {
            display: flex;
            justify-content: space-between;
        }
    }

    .poster-img {
        width: 125px;
        position: absolute;
        right: 20px;
        bottom: 10px;
        z-index: 999;
        margin-top: 0px;
    }

    .myWrapper {
        padding: 20px;
    }

    .banner {
        width: 100%;
        min-height: 464px;
        height: 464px;
    }


    .reward-box {
        position: relative;
        width: 100%;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;


        .bear-palm {
            width: 100%;
            background: #F9F5F0;
            border-radius: 50px;
            // padding: 0 63px;
            font-size: 26px;
            color: #333333;
            // padding-bottom: 45px;

            >p {
                width: 325px;
                height: 70px;
                background: linear-gradient(84deg, #DCC7C1, #D4C7C2);
                border-radius: 0px 0px 40px 40px;
                margin: 0 auto;
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                color: #FFFFFF;
                line-height: 70px;
                text-shadow: 1px 3px 0px rgba(60, 0, 94, 0.52);
                margin-bottom: 36px;
            }

            img {
                width: 100%;
            }

            .reward-bot {
                margin-bottom: 20px !important;
                display: flex;
                color: #666666;
                font-size: 24px;

                p {
                    width: calc(100% - 120px);
                    text-align: left;
                    margin: 0;
                    padding: 0;
                }
            }

            .prizeWrapper {
                margin-top: 40px;
                align-items: center;

                .prizeRank>div {
                    margin-bottom: 10px;
                    font-size: 30px;
                    color: red;
                }

                .prizeRank>.prizeTitle {
                    font-size: 26px;
                    color: #333333;
                }

                img {
                    width: 150px;
                }
            }

        }


    }


    .update-time {
        font-size: 24px;
        color: #999999;
        margin-top: 20px;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }


    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs {
        // display: flex;
        margin: 40px 0 10px 0;

        >div {
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 30px;
        }

        .group-tabs {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 50px;
            overflow-x: auto;
        }
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        margin: 10px 0px 40px 0;
        font-weight: 500;
        text-align: center;
        border-radius: 30PX;
        position: relative;

        &.on {
            color: #333333;

            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: -15px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }



    .group-tab-item {
        // min-width: 22%;
        // margin-right: 30px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;
        padding: 3px 20px;
        margin-right: 23px;
        flex-shrink: 0;

        &.on {
            color: #ffffff;
            background-color: #6E95CE;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }


    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 60px;
        margin-right: 40px;


        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        width: 240px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        width: 180px;
        text-align: center;
    }

    .ranking-bonus {
        width: 180px;
        text-align: center;
    }




    .bg-color {
        height: 90px;
        margin: -30px 0;
        background-color: #E9E9E9;
    }


    .arrivedWrapper {
        margin-top: 20px;

        img {
            width: 100%;
        }
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
        height: 61px;
        line-height: 61px;
        font-size: 26px;
        text-align: center;
        color: #ffffff;
        background: #6E95CE;
        border: 1px solid #465f85;
        border-top-left-radius: 31px;
        border-bottom-left-radius: 31px;
    }
</style>
<style lang="less">
    .ranking {

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>
